//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import wysiwyg from 'vue-wysiwyg';
import InputFile from '../../Widgets/InputFile';
import Multiselect from 'vue-multiselect';
import ProductForm from './ProductForm';
import { request } from "../../requests";
import Swal from 'sweetalert2';
import EmailAddresses from "../../Widgets/EmailAddresses";
import PhoneNumbers from "../../Widgets/PhoneNumbers";
export default {
  props: {
    user_id: {
      type: String,
      required: true
    },
    context: {
      type: String,
      default: null
    },
    context_id: {
      type: String,
      default: null
    },
    isAdmin: {
      type: Number,
      default: 0
    }
  },

  data() {
    return {
      redirect_url: '/' + this.context + '/' + this.context_id,
      message: 'Redirecting to another page...',
      form: {
        context: this.context,
        context_id: this.context_id,
        order_type: null,
        upgrade_flag: 'No',
        site: null,
        file_number: null,
        reference_number: null,
        site_contact_name: null,
        site_contact_email: [],
        site_contact_phone: [],
        site_contact_others: [],
        items: [{
          data: {
            eta: null,
            tat: null,
            sba: 'No',
            fees: null,
            lien: 'No',
            roof: 'No',
            notes: null,
            cercla: 'No',
            product: null,
            roofFlag: false,
            appraisers: [],
            valuationFlag: false,
            is_active_request: 'No',
            sub_products_selected: [],
            // Valuation Fields
            complexity: null,
            propertyType: null,
            transactionType: null,
            transactionTypeOther: null,
            transactionAmount: null,
            interestAppraised: null,
            interestAppraisedOther: null
          },
          errors: {}
        }]
      },
      // upload: {
      //     url: '/forms/orders/files',
      //     csrf: null,
      //     start: false,
      //     params: {},
      //     results: [],
      // },
      sites: {
        items: [],
        loading: false
      },
      company: {
        item: null,
        loading: false
      },
      products: {
        items: [],
        loading: false
      },
      appraisers: {
        items: [],
        loading: false
      },
      company: {
        item: null,
        loading: false
      },
      errors: {},
      loading: false,
      contacts: {
        items: [],
        loading: false
      }
    };
  },

  created() {
    this.contacts.loading = true;
    request({
      method: 'GET',
      url: `/tables/contacts/${this.context}/${this.context_id}`
    }).done(contacts => {
      if (contacts && contacts.length) {
        this.contacts.items = contacts.map(contact => {
          return {
            id: contact.id,
            name: `${contact.first_name} ${contact.last_name}`
          };
        });
      }
    }).always(() => {
      this.contacts.loading = false;
    });
    this.fetchSites();
    this.fetchCompany();
    this.fetchProducts();
    this.fetchAppraisers();
  },

  watch: {
    'form.site': function (value) {
      if (value) {
        this.form.site_contact_name = value.default_site_contact_name || null;
        this.form.site_contact_email = value.default_site_contact_email || [];
        this.form.site_contact_phone = value.default_site_contact_phone || [];
      }
    }
  },
  methods: {
    fetchSites() {
      this.sites.loading = true;
      request({
        method: 'GET',
        data: {
          context: this.context,
          context_id: this.context_id
        },
        url: '/tables/sites'
      }).done(responseData => {
        if (responseData.data && responseData.data.length) {
          this.sites.items = responseData.data;
        }
      }).always(() => {
        this.sites.loading = false;
      });
    },

    fetchCompany() {
      this.company.loading = true;
      request({
        url: `/tables/companies/${this.context_id}`,
        method: 'GET'
      }).done(responseData => {
        if (responseData.data) {
          this.company.item = responseData.data;
        }
      }).always(() => {
        this.company.loading = false;
      });
    },

    fetchProducts() {
      this.products.loading = true;
      request({
        method: 'GET',
        data: {
          context: this.context,
          context_id: this.context_id
        },
        url: '/tables/products'
      }).done(responseData => {
        if (responseData.data && responseData.data.length) {
          this.products.items = responseData.data;
        }
      }).always(() => {
        this.products.loading = false;
      });
    },

    fetchAppraisers() {
      this.appraisers.loading = true;
      request({
        method: 'GET',
        data: {
          context: this.context,
          context_id: this.context_id
        },
        url: '/tables/appraisers'
      }).done(responseData => {
        if (responseData.data && responseData.data.length) {
          this.appraisers.items = responseData.data;
        }
      }).always(() => {
        this.appraisers.loading = false;
      });
    },

    onAdd() {
      this.form.items.push({
        data: {
          eta: null,
          tat: null,
          sba: 'No',
          lien: 'No',
          roof: 'No',
          notes: null,
          cercla: 'No',
          product: null,
          roofFlag: false,
          valuationFlag: false,
          is_active_request: 'No',
          sub_products_selected: [],
          // Valuation Fields
          propertyType: null,
          transactionType: null,
          transactionTypeOther: null,
          transactionAmount: null,
          interestAppraised: null,
          interestAppraisedOther: null
        },
        errors: {}
      });
    },

    onSubmit() {
      this.loading = true;
      this.errors = {};
      const data = this.details;
      request({
        url: '/forms/orders/create',
        data
      }).done(responseData => {
        this.loading = false;

        if (responseData && responseData.message) {
          const text = responseData.message;
          Swal.fire({
            text,
            icon: 'success',
            title: 'Done',
            position: 'center',
            showCloseButton: false,
            showCancelButton: false,
            showConfirmButton: true
          }).then(() => {
            window.location.replace(this.redirect_url);
          });
        }
      }).catch(this.onFail);
    },

    onDelete(product) {
      this.form.items = this.form.items.filter(item => item !== product);
    },

    getItemError(n) {
      if (!this.errors.items) {
        return {};
      }

      return this.errors.items[`item_${n}`] || {};
    },

    onFail(response) {
      this.loading = false;

      switch (response.status) {
        case 400:
          const responseData = response.responseJSON;

          if (responseData && responseData.errors) {
            this.errors = responseData.errors;
          }

          break;
      }
    },

    onOpen(url) {
      if (url) {
        window.open(url);
      }
    }

  },
  computed: {
    details() {
      const siteContactRequired = this.form.items.find(i => i.data.product && i.data.product.site_contact_required === 'Yes');
      this.form.site_contact_email = this.form.site_contact_email.map(i => {
        if (i.value) i.value = i.value.trim();
        return i;
      });
      this.form.site_contact_phone = this.form.site_contact_phone.map(i => {
        if (i.value) i.value = i.value.trim();
        return i;
      });
      return {
        context: this.context,
        context_id: this.context_id,
        order_type: this.form.order_type,
        upgrade_flag: this.form.upgrade_flag,
        site: this.form.site,
        file_number: this.form.file_number,
        reference_number: this.form.reference_number,
        site_contact_name: this.form.site_contact_name,
        site_contact_email: this.form.site_contact_email,
        site_contact_phone: this.form.site_contact_phone,
        site_contact_others: this.form.site_contact_others,
        site_contact_required: siteContactRequired ? true : false,
        items: this.form.items.map(item => {
          const product = item.data.product ? item.data.product.id : null;
          const department = item.data.product ? item.data.product.department : null;
          return { ...item.data,
            product,
            department
          };
        }),
        files: null
      };
    },

    hasItemsError() {
      return this.errors.items && this.errors.items.message;
    },

    getItemsError() {
      if (this.errors.items && this.errors.items.message) {
        return this.errors.items.message;
      }

      return null;
    },

    orderTypes() {
      return ['I would like to submit an order.', 'I am requesting a bid.'];
    },

    siteDisallowUploads() {
      if (this.form.site && this.form.site.sf_perms && this.form.site.sf_perms.length) {
        return this.form.site.sf_perms.includes('Disallow Uploads');
      }

      return false;
    },

    siteDisallowDownloads() {
      if (this.form.site && this.form.site.sf_perms && this.form.site.sf_perms.length) {
        return this.form.site.sf_perms.includes('Disallow Downloads');
      }

      return false;
    },

    siteShareLink() {
      if (this.form.site) {
        return this.form.site.sf_share_link;
      }

      return null;
    },

    siteRequestLink() {
      if (this.form.site) {
        return this.form.site.sf_request_link;
      }

      return null;
    }

  },
  components: {
    EmailAddresses,
    PhoneNumbers,
    InputFile,
    ProductForm,
    Multiselect,
    'wysiqyg': wysiwyg
  }
};